import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function Connect() {
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24" data-testid="connect-page">
      <div className="overline mb-3">/connect — onboarding</div>
      <h1 className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter mb-6">
        Get connected
      </h1>
      <p className="text-lg text-slate-300 max-w-3xl leading-relaxed mb-12">
        About 15 minutes from unboxing to your first message. Follow the path:
      </p>

      <ol className="space-y-4 mb-12">
        {[
          { n: "01", t: "Pick a radio", d: "See our recommended boards and their tradeoffs.", to: "/devices" },
          { n: "02", t: "Flash MeshCore firmware", d: "Web flasher or CLI — both walk you through it.", to: "/devices" },
          { n: "03", t: "Apply USA/Canada presets", d: "Frequency, bandwidth, spread factor — the values you need.", to: "/settings" },
          { n: "04", t: "Pair via Bluetooth", d: "Download the MeshCore companion app and pair.", to: "/meshcore" },
          { n: "05", t: "Say hello in the public channel", d: "Many are active throughout the day to discuss and learn", to: "" },
        ].map((s) => (
          <li key={s.n}>
            <Link
              to={s.to}
              className="group flex items-center gap-6 bg-[#13161C] border border-[#272E3A] hover:border-[#FF5500] p-6 transition-colors"
            >
              <span className="font-mono text-2xl text-[#FF5500] font-bold">{s.n}</span>
              <div className="flex-1">
                <div className="font-display font-bold text-white text-xl mb-1">{s.t}</div>
                <div className="text-slate-400 text-sm">{s.d}</div>
              </div>
              <ArrowRight className="w-5 h-5 text-[#FF5500] group-hover:translate-x-1 transition-transform" />
            </Link>
          </li>
        ))}
      </ol>

      <div className="bg-[#13161C] border border-[#272E3A] p-6 lg:p-8">
        <div className="overline mb-2">Final step</div>
        <h2 className="font-display font-bold text-white text-2xl mb-3">Join the Discord</h2>
        <p className="text-slate-400 mb-5">Real-time help, gear swaps, repeater coordination, and field reports.</p>
        <a
          href="https://discord.gg/3TPXsHBv6t"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="connect-discord-btn"
          className="inline-flex items-center gap-2 px-6 py-3 bg-[#FF5500] hover:bg-[#FF7326] text-white font-semibold transition-colors"
        >
          Join Discord <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
